const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  }
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async getDataAll({ commit }, payload) {
    try {
      let url;
      if (!payload.classSectionId) {
        url = `/api/pages/classroom/${payload.classroomId}/course/${payload.courseId}?search=${payload.search}`;
      } else {
        url = `/api/pages/class-section/${payload.classSectionId}?search=${payload.search}`;
      }
      const {
        data: { data }
      } = await window.axios.get(`${url}`);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchDetail({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/pages/${payload}`);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  save({ commit }, payload) {
    let url;
    if (!payload.classSectionId) {
      url = `/api/pages/classroom/${payload.classroomId}/course/${payload.courseId}`;
    } else {
      url = `/api/pages/class-section/${payload.classSectionId}`;
    }
    return window.axios.post(`${url}`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  update({ commit }, payload) {
    return window.axios.put(`/api/pages/${payload.id}`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  destroy({ commit }, payload) {
    return window.axios.delete(`/api/pages/${payload}`);
  }
};

export default { namespaced, state, getters, mutations, actions };
